// third-party

// assets
import notificationIcon from "../../assets/icons/notification-03.svg";

// icons
const icons = {
  notifs: () => <img src={notificationIcon} alt="expert icon" />,
};

// ==============================|| MENU ITEMS - NOTIFICATIONS ||============================== //

// Create a static menu item instead of one using hooks
const notifications = {
  id: 'notifications',
  title: 'Notifications',
  type: 'group',
  url: 'admin/notifications',
  icon: icons.notifs,
  // We'll set up a dynamic badge in the drawer content component
};

export default notifications;
